/**
 * Merge multiple refs into a single ref callback.
 * @param refs List of refs to merge
 * @returns A ref callback that merges the refs
 */
export function mergeRefs<T = any>(
  ...refs: (React.Ref<T> | React.RefObject<T> | undefined | null)[]
): React.RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    }
  };
}
